export default "__VITE_ASSET__CEcNk5wg__"